"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _utils = require("../utils");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var validate = (value, isRequired, minValue, maxValue) => {
  var isValid = true;

  // First check if the field is required
  // if so, then check to make sure value is not empty
  isValid = isValid && (isRequired ? value !== '' : true);

  // Ensure the value is indeed a number
  // Or in the case of field not being required(checked above): undefined
  // Value changing from undefined to Defined will no longer be supported
  // in the upcoming versions of React.
  isValid = isValid && !Number.isNaN(Number(value));
  // Check if minValue and maxValue are set, ensure value meets the criteria
  isValid = isValid && (value === '' || minValue === undefined || value >= minValue);
  isValid = isValid && (value === '' || maxValue === undefined || value <= maxValue);
  return isValid;
};
var NumberField = props => {
  var {
    value = '',
    onChange = () => {},
    // function signature: (value, isValid) => {}
    isRequired = false,
    minValue,
    maxValue,
    clickedSubmit = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    customErrorMessage,
    label = _staticContent.NUMBER_FIELD.DEFAULT_LABEL,
    hint,
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    placeholder = '',
    inputRef = /*#__PURE__*/_react.default.createRef(),
    isReadOnly = false
  } = props;
  var [validationError, setValidationError] = (0, _react.useState)(undefined);
  var [validationFeedback, setValidationFeedback] = (0, _react.useState)(undefined);
  var [numberFieldValue, setNumberFieldValue] = (0, _react.useState)(value);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  var updateValidationError = (0, _react.useCallback)(isValid => {
    var detailedError = customErrorMessage || _staticContent.NUMBER_FIELD.VALIDATION_ERROR[language];
    var hasMinValue = minValue !== undefined;
    var hasMaxValue = maxValue !== undefined;
    if (hasMinValue || hasMaxValue) {
      var minMaxMessage = '';
      if (hasMinValue && hasMaxValue) {
        minMaxMessage += " ".concat(_staticContent.NUMBER_FIELD.MIN_MAX_MESSAGE.MIN[language], " ").concat(minValue, ", ").concat(_staticContent.NUMBER_FIELD.MIN_MAX_MESSAGE.MAX[language], " ").concat(maxValue);
      } else if (hasMinValue) {
        minMaxMessage += " ".concat(_staticContent.NUMBER_FIELD.MIN_MAX_MESSAGE.MIN[language], " ").concat(minValue);
      } else {
        minMaxMessage += " ".concat(_staticContent.NUMBER_FIELD.MIN_MAX_MESSAGE.MAX[language], " ").concat(maxValue);
      }
      detailedError = customErrorMessage !== '' ? customErrorMessage : "".concat(_staticContent.NUMBER_FIELD.VALIDATION_ERROR[language], ", ").concat(minMaxMessage);
    }
    setValidationError(isValid ? undefined : detailedError);
    setValidationFeedback(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
  }, [customErrorMessage, language, minValue, maxValue]);
  (0, _react.useEffect)(() => {
    onChange(numberFieldValue, validate(numberFieldValue, isRequired, minValue, maxValue));
  }, [isRequired, maxValue, minValue, onChange, numberFieldValue]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      var isValid = validate(numberFieldValue, isRequired, minValue, maxValue);
      updateValidationError(isValid);
    }
  }, [clickedSubmit, isRequired, maxValue, minValue, updateValidationError, numberFieldValue]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        var isValid = validate(numberFieldValue, isRequired, minValue, maxValue);
        updateValidationError(isValid);
      }
    }
  }, [buttonControlPressed, inputRef, currentStepReferences, updateValidationError, numberFieldValue, isRequired, maxValue, minValue]);
  var onFieldChange = val => {
    setNumberFieldValue(val);
  };
  var onFieldBlur = val => {
    var isValid = validate(val, isRequired, minValue, maxValue);
    updateValidationError(isValid);
  };
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.TextInput, {
    ref: inputRef,
    label: (0, _utils.formatLabel)(label, isRequired, language),
    hint: hint,
    hintPosition: hintPosition,
    type: _constants.INPUT_FIELD_TYPE.NUMBER,
    variant: {
      numeric: true
    },
    value: numberFieldValue,
    placeholder: placeholder,
    onChange: onFieldChange,
    onBlur: e => onFieldBlur(e.target.value),
    validation: validationFeedback,
    feedback: validationError,
    "data-di-mask": true,
    inactive: isReadOnly
  }));
};
NumberField.propTypes = {
  label: _propTypes.default.string,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  minValue: _propTypes.default.number,
  maxValue: _propTypes.default.number,
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  inputRef: _propTypes.default.object,
  customErrorMessage: _propTypes.default.string
};
var _default = exports.default = NumberField;